import { useOutletContext } from "react-router-dom";
import locationIcon from "../../../../assets/images/blue-marker.png"; 
import { IServiceProvider } from "../../../../interface/ProfileInterfaces";
import ServiceProvidersMap from "../../component/ServiceProvidersMap";
import { TitleWithIcon } from "../../../../Share";
 
const LocationInfo = () => {
  const profileData = useOutletContext<IServiceProvider>();
  const providersArray: IServiceProvider[] = profileData ? [profileData] : [];

  return (
    <div className="flex flex-col gap-4"> 
      <TitleWithIcon
        title={`${profileData?.City?.Name ?? ""}${
          profileData?.Area?.Name ? " - " + profileData?.Area?.Name : ""
        } ${profileData?.Address ? " - " + profileData?.Address : ""}`}
        icon={locationIcon}
      />
      <ServiceProvidersMap items={providersArray} />
    </div>
  );
};

export default LocationInfo;
